import { render } from "./imgs-viewer.vue?vue&type=template&id=91e6ba40&scoped=true"
import script from "./imgs-viewer.vue?vue&type=script&lang=js"
export * from "./imgs-viewer.vue?vue&type=script&lang=js"

import "./imgs-viewer.vue?vue&type=style&index=0&id=91e6ba40&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e6ba40"]])

export default __exports__